import Vue from 'vue';
export default Vue.extend({
    props: {
        input: Object
    },
    data: function () {
        return {
            value: this.input.value
        };
    },
    created: function () {
        var selected = this.input.values.find(function (value) { return value.selected === true || value.selected === 'true'; });
        if (selected) {
            this.value = selected.value || selected.label;
        }
    }
});
